module.exports = __webpack_public_path__ + "static/img/8.e9bccea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/8.png
// module id = AxvL
// module chunks = 0